import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class PersonneContainerCession extends ShadowDOMElement {
	static className = "PersonneContainerCession";
	
	static properties = {
		name: { type: String, attribute: "name" },
		visible: {
			type: Boolean, attribute: "visible", reflect: true,
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		},
		showCapital: {
			type: Boolean, attribute: "show-capital", reflect: true,
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		}
	};

	constructor() {
		super();
		this.name = `personne-type`;
		this.visible = true;
		this.showCapital = false;
	}

	render() {
    return html`
      <div style="display: ${this.visible ? 'block' : 'none'}">
        <row-wrapper>
          <radio-buttons-field
            name="${this.name}"
            .options="${[
              { title: "Personne physique", value: "physique" },
              { title: "Personne morale", value: "morale" },
            ]}"
            value="physique"
            @change="${this.handleRadioChange}"
          ></radio-buttons-field>
        </row-wrapper>
        <div-container id="physique-container" visible="true">
          <personne-physique-cession></personne-physique-cession>
        </div-container>
        <div-container id="morale-container" visible="false">
          <personne-morale-cession show-capital="${this.showCapital}"></personne-morale-cession>
        </div-container>
      </div>
    `;
	}

	handleRadioChange(event) {
		if (!event || !event.detail || !event.detail.value)
			return;
		
		this.#updateContainers (event.detail.value);
	}
	
	#updateContainers (selectedValue){
		if (!selectedValue)
			selectedValue = this.shadowRoot.querySelectorAll ("radio-buttons-field")[0].value;
		
		const physiqueContainer = this.shadowRoot.querySelector ("#physique-container");
		const moraleContainer = this.shadowRoot.querySelector ("#morale-container");
	
		if (physiqueContainer && moraleContainer) {
			if (selectedValue === "physique") {
				physiqueContainer.visible = true;
				moraleContainer.visible = false;
			} else if (selectedValue === "morale") {
				physiqueContainer.visible = false;
				moraleContainer.visible = true;
			} else {
				physiqueContainer.visible = false;
				moraleContainer.visible = false;
			}
		}
	}
	
	isTransient (){
		return false;
	}

	getValues (){
		return {
			"visible" : this.visible,
			"showCapital" : this.showCapital,
			... super.getValues ()
		}
	}

	setValues (values){
		this.visible = values.visible;
		this.showCapital = values.showCapital;
		this.requestUpdate ();
		super.setValues (values);
		this.#updateContainers ();
	}

}

customElements.define ("personne-container-cession", PersonneContainerCession);
